import React, { memo } from 'react';

import * as M from '@mui/material';

import AxlButton from '../Button';
import ListBoxChat from '../ListBoxChat';

const styles = {
  root: {},
  container: {
    height: '100%',
    flexWrap: 'nowrap',
    flexDirection: 'column',
  },
  controls: {
    display: 'flex',
    alignContent: 'flex-start',
    flexDirection: 'row',
    width: '100%',
    overflowX: 'scroll',
  },
  lists: {},
};

const ChatBox = (props) => {
  const { listMsg, checkToLoadMore, user, id } = props;
  return (
    <M.Box height={1}>
      <M.Grid container sx={styles.container}>
        <M.Grid size={12} container direction={'row'} style={{ overflow: 'hidden' }}>
          <M.Grid container direction={`column`} wrap={`nowrap`} style={{ height: '100%' }}>
            <M.Grid size={12} style={{ overflow: 'hidden' }}>
              <ListBoxChat user={user} listMsg={listMsg} checkToLoadMore={checkToLoadMore} />
            </M.Grid>
          </M.Grid>
        </M.Grid>
        {!!listMsg.length && (
          <M.Box align={'center'} pb={1}>
            <AxlButton
              style={{ padding: '5px 15px' }}
              variant="outlined"
              color={`primary.gray`}
              bgcolor={`primary.white`}
              href={`${import.meta.env.REACT_APP_SUPPORT_URL}/messages/${id}`}
              target={`_blank`}
            >{`Goto Chat`}</AxlButton>
          </M.Box>
        )}
      </M.Grid>
    </M.Box>
  );
};
export default memo(ChatBox);
